/* eslint-disable react/forbid-prop-types */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import {
  faChevronUp,
  faChevronDown,
  faHandHoldingBox as faHandHoldingBoxSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { faMinusCircle } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'react-tooltip';
import { flatten } from 'lodash';

import 'react-tooltip/dist/react-tooltip.css';

function DraftPickList({
  name,
  draftItems,
  handleRemoveFromPickList,
  handleNameChange,
}) {
  const [collapsedGroups, setCollapsedGroups] = useState([]);

  const onToggleCollapseGroup = (groupId) => {
    let nextCollapsedGroups;
    if (collapsedGroups.includes(groupId)) {
      nextCollapsedGroups = collapsedGroups.filter((id) => id !== groupId);
    } else {
      nextCollapsedGroups = [...collapsedGroups, groupId];
    }

    setCollapsedGroups(nextCollapsedGroups);
  };

  return (
    <div className="info-box border-secondary">
      <Tooltip id="draft-tooltip" />
      <div className="info-header bg-secondary">
        <h3>Pick List</h3>
        <FontAwesomeIcon icon={faHandHoldingBoxSolid} />
      </div>
      <div className="info-content">
        <Form.Group className="mb-3">
          <Form.Label>List Name</Form.Label>
          <Form.Control
            type="text"
            id="list-name"
            value={name}
            onChange={(e) => handleNameChange(e.target.value)}
          />
        </Form.Group>

        <Table hover size="sm">
          {draftItems.map((group) => {
            const isGroupCollapsed = collapsedGroups.includes(group[0].GroupID);
            const isGroup = !!group[0].GroupID;

            return (
              <tbody>
                {isGroup && (
                  <tr key={group[0].GroupID} className="picklist-group-header">
                    <td>
                      {group[0].GroupName || group.ItemName} ({group.length}{' '}
                      items)
                      <FontAwesomeIcon
                        onClick={() => onToggleCollapseGroup(group[0].GroupID)}
                        icon={isGroupCollapsed ? faChevronDown : faChevronUp}
                        size="sm"
                        className="text-primary ps-2"
                      />
                    </td>
                    <td className="text-end">
                      <a
                        data-tooltip-id="draft-tooltip"
                        data-tooltip-content="Remove from pick list"
                        href="#"
                        className="btn btn-link"
                        onClick={(e) => {
                          group.forEach((item) => {
                            handleRemoveFromPickList(item);
                          });
                          e.preventDefault();
                        }}
                      >
                        <FontAwesomeIcon icon={faMinusCircle} />
                      </a>
                    </td>
                  </tr>
                )}

                {!isGroupCollapsed &&
                  group.map((item) => (
                    <tr key={`${item.InventoryItemID}`}>
                      <td className={isGroup ? 'ps-5' : 'ps-0'}>
                        {item.ItemName}
                      </td>
                      <td className="text-end">
                        <a
                          data-tooltip-id="draft-tooltip"
                          data-tooltip-content="Remove from pick list"
                          href="#"
                          className="btn btn-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handleRemoveFromPickList(item);
                          }}
                        >
                          <FontAwesomeIcon icon={faMinusCircle} />
                        </a>
                      </td>
                    </tr>
                  ))}
              </tbody>
            );
          })}
        </Table>
        <Link
          to="review"
          className="btn btn-primary"
          disabled={!draftItems?.length || !name}
          state={{ name, items: flatten(draftItems) }}
        >
          Review and Request
        </Link>
      </div>
    </div>
  );
}

DraftPickList.propTypes = {
  name: PropTypes.string.isRequired,
  draftItems: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  handleRemoveFromPickList: PropTypes.func.isRequired,
  handleNameChange: PropTypes.func.isRequired,
};

export default DraftPickList;
